/* eslint-disable no-unused-vars */
/* Common functions for Box */

import { PPI } from '../constants';

/**
 * Rounds a number to at most N decimal places.
 * It will only use as many decimals as needed up to N, providing precise control over the formatting of numerical output.
 *
 * @param {number} num - The number to be rounded.
 * @param {number} decimalPlaces - The number of decimal places to round to, default is 4.
 * @return {number} The rounded number with up to N decimal places.
 */
export const roundToDecimalPlaces = (num, decimalPlaces = 4) => {
  return parseFloat(num.toFixed(decimalPlaces));
}

/**
 * Convert inches to pixels
 *
 * @param {number} inch - Inches.
 * @param {number} ppi - Pixels Per Inch, by default it uses the constant PPI which is 96.
 * @param {number} decimalPlaces - Number of decimal places, default is 4.
 * @returns {number} Pixels
 */
export const inchesToPixels = (inch, ppi = PPI, decimalPlaces = 4) => {
  return roundToDecimalPlaces(inch * ppi)
}

// an alias for inchesToPixels
export const toPx = inchesToPixels;

// Function to calculate the y-coordinate of the second point from first point and angle
export const calculateSecondPointYFromAngleAndDistance = (x1, y1, x2, angle) => {
  // Calculate the change in x coordinates
  var deltaX = x2 - x1;

  // Calculate the change in y coordinate based on the angle
  var deltaY = Math.tan(angle * Math.PI / 180) * deltaX;

  // Calculate the y-coordinate of the second point
  var y2 = y1 + deltaY;

  return {x: x2 , y: y2};
}

// Function to calculate the x-coordinate of the second point from first point and angle
export const calculateSecondPointXFromAngleAndDistance = (x1, y1, y2, angle) => {
  // Calculate the change in y coordinates
  var deltaY = y2 - y1;

  // Calculate the change in x coordinate based on the angle
  var deltaX = deltaY / Math.tan(angle * Math.PI / 180);

  // Calculate the x-coordinate of the second point
  var x2 = x1 + deltaX;

  return {x: x2, y: y2};
}

